import React, { useMemo } from "react";
import {
  ActionIcon,
  Grid,
  MultiSelect,
  Group,
  Button,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconHelp } from "@tabler/icons";
import {
  FUND_FILTER_COLUMNS,
  buildFundDistinctValues,
} from "../helpers/approvalFundListFundsUtils";

const getFilterValues = (tableFilterQuery, field) =>
  tableFilterQuery[field]?.$in ?? [];

const FilterLabel = ({ label, tip }) => {
  if (!tip) return label;

  return (
    <Group spacing={4} noWrap>
      <span>{label}</span>
      <Tooltip label={tip} multiline width={280} withArrow>
        <ActionIcon
          size="xs"
          variant="transparent"
          color="gray"
          tabIndex={-1}
          aria-label={`${label} help`}
        >
          <IconHelp size={14} stroke={1.5} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
};

const OrderArFormFundFilters = ({
  funds,
  tableFilterQuery,
  onFilterChange,
  filteredCount,
  totalCount,
  listTotalCount,
}) => {
  const filterOptions = useMemo(
    () =>
      FUND_FILTER_COLUMNS.map((col) => ({
        col,
        field: col.filter.field,
        label: col.filter.label,
        tip: col.filter.tip,
        data: buildFundDistinctValues(funds, col),
      })),
    [funds]
  );

  const hasActiveFilters = Object.keys(tableFilterQuery).length > 0;

  return (
    <div>
      <Grid gutter="md" mb="sm">
        {filterOptions.map(({ field, label, tip, data }) => (
          <Grid.Col key={field} span={12} sm={6} lg={4}>
            <MultiSelect
              label={<FilterLabel label={label} tip={tip} />}
              placeholder="All"
              data={data}
              value={getFilterValues(tableFilterQuery, field)}
              onChange={(values) => onFilterChange(field, values, data)}
              searchable
              clearable
              maxDropdownHeight={200}
              nothingFound="No options"
            />
          </Grid.Col>
        ))}
      </Grid>
      <Group position="apart" mb="sm">
        <Text size="xs" color="dimmed">
          {listTotalCount != null && listTotalCount !== totalCount
            ? `Showing ${filteredCount} of ${totalCount} RPQ-eligible funds (${listTotalCount} in approved list)`
            : `Showing ${filteredCount} of ${totalCount} funds`}
        </Text>
        {hasActiveFilters && (
          <Button
            variant="subtle"
            size="xs"
            compact
            onClick={() => onFilterChange(null)}
          >
            Clear filters
          </Button>
        )}
      </Group>
    </div>
  );
};

export default OrderArFormFundFilters;
